module.exports = __webpack_public_path__ + "static/media/internal-server-error.5f86e628.svg";